export const locales = ["tr", "en"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "tr";
export const localeCookieName = "wio_veyra_locale";

export function isLocale(value: string | undefined): value is Locale {
  return locales.some((locale) => locale === value);
}
